import {Box, SvgIcon, SvgIconProps} from "@mui/material";
import {TrainIconProps} from "./TrainIcon";

export interface LogOutIconProps extends SvgIconProps {
    scolor?: string;
}

const LogOutIcon = ({ scolor = "#78909C", ...props }: LogOutIconProps) => {
    return (
        <SvgIcon style={{fill: "none"}} {...props}>
            <path d="M0 0h24v24H0V0"/>
            <Box strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                 d="m17 16 4-4-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
                 component="path" sx={{
                                         stroke: scolor,
                                         '&:hover': {
                                             stroke: 'white', // Background color on hover
                                         },
                                     }}/></SvgIcon>
    );
};

export default LogOutIcon;